import { render, staticRenderFns } from "./ModalEditPricelist.vue?vue&type=template&id=832d98cc&scoped=true&"
import script from "./ModalEditPricelist.vue?vue&type=script&lang=js&"
export * from "./ModalEditPricelist.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditPricelist.vue?vue&type=style&index=0&id=832d98cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832d98cc",
  null
  
)

export default component.exports